export default __webpack_public_path__ + "static/media/money.444ac1b7.svg";